import React, { useState } from "react";

const OptionTypeResponse = ({ Question, options, onSelect }) =>{
    const [selectedOption, setSelectedOption] = useState(null);

    const handleOptionClick = (option) => {
        setSelectedOption(selectedOption === option ? null : option);
        if (onSelect) {
            onSelect(option); // ✅ Ensure `onSelect` is triggered
        }
    };

    return(
        <div className="left-chatbot-message-section">
                    
               
        <div className="loan-type-response">
            {/* <div className="loan-type-response-title">
                {Question}
            </div> */}
            <div className="loan-type-response-content">
                <div className="message-cancel">
                    <img src="/images/message-cancel-icon.png" alt="cross-icon"/>
                </div>
                <div className="loan-type-response-content-option">
                    {options.map((option) => (
                        <div 
                            key={option} 
                            className={`loan-type-response-content-option-box ${selectedOption === option ? "selected" : ""}`} 
                            onClick={() => handleOptionClick(option)}
                        >
                            {option}
                        </div>
                    ))}
                </div>
                <div className="chat-response-button">
                    <img src={selectedOption ? "/images/message-send-active-icon.png" : "/images/message-send-disabled-icon.png"} alt="message-send-icon"/>
                </div>
            </div>

        </div>
        </div>
    )
}

export default OptionTypeResponse;